module.exports = __webpack_public_path__ + "static/img/paycenter-logo.dce7eec8.svg";